import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import "./input.scss";

const InputField = ({
  intl: { messages },
  name,
  id,
  className,
  label,
  value,
  error,
  onChange,
  helperText,
  isMultiline,
  isRequired,
  max,
  disabled,
  type,
  placeholder,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const lang = useSelector((state) => state.lang);

  return (
    <TextField
      disabled={disabled}
      className={`my-3 input ${className ? className : ""}`}
      name={name}
      id={id}
      type={type && !showPassword ? type : "text"}
      label={isRequired ? label + " *" : label}
      InputProps={{
        maxLength: max ? max : isMultiline ? 500 : 50,
        endAdornment: type === "password" && !disabled && (
          <InputAdornment className={lang === "ar" ? "eye-icon icon-left" : "eye-icon"}>
            <Tooltip
              title={showPassword ? messages.common.hide : messages.common.show}
              placement="top"
            >
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      fullWidth
      value={value}
      error={error}
      helperText={error && helperText}
      onChange={onChange}
      multiline={isMultiline}
      rows={isMultiline ? 3 : 1}
      placeholder={placeholder}
    />
  );
};

export default injectIntl(InputField);
